"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Sections = require("sections");
var StorePageTemplate = /** @class */ (function (_super) {
    __extends(StorePageTemplate, _super);
    function StorePageTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StorePageTemplate.prototype.render = function () {
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement("section", { className: "" },
                React.createElement(Sections.StoreDetail, __assign({}, this.props)),
                React.createElement(Sections.USP, __assign({}, this.props, { section: this.props.data.section.usp })),
                React.createElement(Sections.CTA, __assign({}, this.props, { section: this.props.data.section.cta })))));
    };
    return StorePageTemplate;
}(React.Component));
exports.StorePageTemplate = StorePageTemplate;
